import { render, staticRenderFns } from "./FormModalUnassignedWork.vue?vue&type=template&id=443a34aa&"
import script from "./FormModalUnassignedWork.vue?vue&type=script&lang=js&"
export * from "./FormModalUnassignedWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports